export default function imagesHttpService($http, RESOURCES, API_V2_HEADER) {
  function getImageById(imageId) {
    return $http.get(RESOURCES.DEFAULT_IMAGES + '/' + imageId);
  }

  function getImagesByCategories(categoriesId) {
    return $http.get(RESOURCES.DEFAULT_IMAGES + '/categories', {
      params: {
        categoryIds: categoriesId,
      },
    });
  }

  function uploadImage(image) {
    return $http.post(RESOURCES.DEFAULT_IMAGES, image, {
      headers: API_V2_HEADER.headers,
    });
  }

  function updateImage(imageId, image) {
    return $http.put(RESOURCES.DEFAULT_IMAGES + '/' + imageId, image);
  }

  function deleteImageById(imageId) {
    return $http.delete(RESOURCES.DEFAULT_IMAGES + '/' + imageId);
  }
  return {
    getImageById: getImageById,
    getImagesByCategories: getImagesByCategories,
    uploadImage: uploadImage,
    updateImage: updateImage,
    deleteImageById: deleteImageById,
  };
}



// WEBPACK FOOTER //
// ./src/app/images/imagesHttp.service.js